<template>
  <div class="dropdown is-active">
    <div class="dropdown-menu">
      <div class="dropdown-content max-h-[300px] overflow-y-auto">
        <template v-if="items.length">
          <a
            v-for="(item, index) in items"
            :key="index"
            class="dropdown-item"
            :class="{ 'bg-gray-100 !text-black': index === selected_index }"
            @click="selectItem(index)"
          >
            {{ item.label }}
          </a>
        </template>
        <template v-else>
          <span class="dropdown-item">
            {{ i18n.global.t('select.actions.noResults') }}
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n/index';

export default {
  name: 'MentionDropdownList',

  props: {
    items: {
      type: Array,
      required: true,
    },

    command: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      selected_index: 0,
      i18n,
    };
  },

  watch: {
    items() {
      this.selected_index = 0;
    },
  },

  methods: {
    onKeyDown({ event }) {
      if (event.key === 'ArrowUp') {
        this.upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        this.downHandler();
        return true;
      }

      if (event.key === 'Enter' || event.key === 'Tab') {
        this.enterHandler();
        return true;
      }

      return false;
    },

    upHandler() {
      this.selected_index = (this.selected_index + this.items.length - 1) % this.items.length;
    },

    downHandler() {
      this.selected_index = (this.selected_index + 1) % this.items.length;
    },

    enterHandler() {
      this.selectItem(this.selected_index);
    },

    selectItem(index) {
      const item = this.items[index];

      if (item) {
        this.command({ label: item.label, id: item.id });
      }
    },
  },
};
</script>
